// extracted by mini-css-extract-plugin
module.exports = {"ReferenceSlider__Slide":"Slide_ReferenceSlider__Slide__RSidK","teaser":"Slide_teaser__5v8v_","headline":"Slide_headline__1L9r5","text":"Slide_text__PFQDe"};